import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../shared/state/appContext'
import { trackAppointmentBookingSelection } from '../../../../shared/utils/tracking/tracking'
import {
  MoneyTopicFlow,
  PreviousAppointmentFlow,
  SolicitorFlow,
  TechTopicFlow,
} from '../../pageFlowData'
import { previousAppointmentData } from './data'

export const PreviousAppointment: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, PreviousAppointmentFlow.VIEW_NAME, { id, index })
  }

  const chooseStep = (id: string) => {
    if (id === 'yes') {
      window.location.href = '/my-appointments'
    }
    switch (type) {
      case 'tech':
        return TechTopicFlow
      case 'money':
        return MoneyTopicFlow
      case 'legal':
        return SolicitorFlow
    }
  }

  const handleDispatch = (id: string) => {
    const step = chooseStep(id)
    dispatch({ type: 'UPDATE_STEP', data: step?.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: step?.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = previousAppointmentData

  return (
    <div>
      <PillButtonPage buttons={buttons} handleSubmit={handleSubmit} imgObj={imgObj} title={title} />
    </div>
  )
}
